<script setup lang="ts">
import { computed } from 'vue';
import { CircleAlert, CircleCheck, Clock } from '@lucide/vue';
import { cn } from '@/lib/utils';

type Availability = 'available' | 'planned' | 'coming-soon';

const props = defineProps<{ status: Availability; class?: string }>();

const statuses = {
    available: {
        icon: CircleCheck,
        label: 'Available',
        class: 'border-secondary/30 bg-secondary/10 text-foreground',
        iconClass: 'text-secondary',
    },
    planned: {
        icon: Clock,
        label: 'Planned for launch',
        class: 'border-border bg-muted text-muted-foreground',
        iconClass: 'text-muted-foreground',
    },
    'coming-soon': {
        icon: CircleAlert,
        label: 'Coming later',
        class: 'border-border bg-muted text-muted-foreground',
        iconClass: 'text-muted-foreground',
    },
} as const;

const status = computed(() => statuses[props.status]);
</script>

<template>
    <span
        :class="
            cn(
                'inline-flex shrink-0 items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium',
                status.class,
                props.class,
            )
        "
    >
        <component
            :is="status.icon"
            :class="cn('size-3', status.iconClass)"
            aria-hidden="true"
        />
        {{ status.label }}
    </span>
</template>
